import { render } from "./DeleteApplicationModal.vue?vue&type=template&id=65b43d1f"
import script from "./DeleteApplicationModal.vue?vue&type=script&lang=js"
export * from "./DeleteApplicationModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__